/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ServiceType {
  PHARMACY_STORE = 'Pharmacy Store',

  PHARMACY_SUPPLIER = 'Pharmacy Supplier',

  LAB = 'Diagnosis Lab',

  DOCTOR = 'Doctor',

  HOSPITAL_OP = 'Hospital - OP Only',

  HOSPITAL_IP = 'Hospital - IP Only',

  HOSPITAL_ALL = 'Hospital All Services',
}
